export default "__VITE_ASSET__89SLkhlZ__"